exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demand-warp{color:#2a2a2a;padding:60px 60px 80px}.demand-warp .demand-title{font-size:30px;font-weight:600;margin-bottom:15px;text-align:center}.demand-warp .demand-detail{width:700px;margin:0 auto 40px}.demand-warp .demand-detail p:first-child{margin-bottom:10px}.demand-warp .demand-detail .deco-under{text-decoration:underline}.demand-warp .demand-form{width:500px;margin:0 auto}.mm-datepicker-popper{width:300px}.mm-select-dropdown--multiple{overflow:hidden}", ""]);

// exports
